if (!customElements.get('sticky-atc-bar')) {
  customElements.define(
    'sticky-atc-bar',
    class StickyAtcBar extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-sticky-submit]');
        this.priceEl = this.querySelector('[data-sticky-price]');
        this.variantEl = this.querySelector('[data-sticky-variant]');
        this.imageEl = this.querySelector('[data-sticky-image]');
        this.hasTiers = false;
        this.variantTitle = this.variantEl ? this.variantEl.textContent.trim() : '';
        this.tierLabel = '';

        const productInfo = document.querySelector('product-info');
        this.form = productInfo ? productInfo.querySelector('form[data-type="add-to-cart-form"]') : null;
        this.cta = productInfo ? productInfo.querySelector('.product-form__submit') : null;

        if (!this.form || !this.cta || !this.button) {
          this.hidden = true;
          return;
        }

        this.button.setAttribute('form', this.form.getAttribute('id'));
        this.syncButton();

        this.ctaObserver = new MutationObserver(() => this.syncButton());
        this.ctaObserver.observe(this.cta, {
          attributes: true,
          attributeFilter: ['disabled'],
          childList: true,
          subtree: true,
          characterData: true,
        });

        this.visibilityObserver = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];
            const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.toggle(scrolledPast);
          },
          { threshold: 0 }
        );
        this.visibilityObserver.observe(this.cta);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribers = [
            subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => this.onVariantChange(data)),
            subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.setLoading(false)),
            subscribe(PUB_SUB_EVENTS.cartError, () => this.setLoading(false)),
          ];
        }

        this.onTierChange = (event) => {
          const detail = event.detail || {};
          this.hasTiers = true;
          this.tierLabel = detail.label || '';
          if (this.priceEl && detail.total) this.priceEl.textContent = detail.total;
          this.renderVariantLine();
        };
        document.addEventListener('bangle:tier-change', this.onTierChange);
        const tiers = productInfo.querySelector('bangle-tiers');
        if (tiers && tiers.lastDetail) this.onTierChange({ detail: tiers.lastDetail });

        this.onSubmit = () => {
          if (this.classList.contains('is-visible')) this.setLoading(true);
        };
        this.form.addEventListener('submit', this.onSubmit);
      }

      disconnectedCallback() {
        if (this.ctaObserver) this.ctaObserver.disconnect();
        if (this.visibilityObserver) this.visibilityObserver.disconnect();
        if (this.unsubscribers) this.unsubscribers.forEach((unsubscribe) => unsubscribe());
        document.removeEventListener('bangle:tier-change', this.onTierChange);
        if (this.form) this.form.removeEventListener('submit', this.onSubmit);
        document.body.classList.remove('sticky-atc-visible');
      }

      toggle(show) {
        this.classList.toggle('is-visible', show);
        this.setAttribute('aria-hidden', String(!show));
        document.body.classList.toggle('sticky-atc-visible', show);
      }

      syncButton() {
        if (!this.button || !this.cta) return;
        this.button.toggleAttribute('disabled', this.cta.hasAttribute('disabled'));
        if (this.cta.hasAttribute('disabled')) {
          const ctaLabel = this.cta.querySelector('span');
          const ourLabel = this.button.querySelector('span');
          if (ctaLabel && ourLabel) ourLabel.textContent = ctaLabel.textContent.trim();
        } else if (this.defaultLabel) {
          const ourLabel = this.button.querySelector('span');
          if (ourLabel) ourLabel.textContent = this.defaultLabel;
        }
        if (!this.defaultLabel && !this.cta.hasAttribute('disabled')) {
          const ourLabel = this.button.querySelector('span');
          this.defaultLabel = ourLabel ? ourLabel.textContent.trim() : '';
        }
      }

      setLoading(isLoading) {
        if (!this.button) return;
        this.button.classList.toggle('loading', isLoading);
        this.button.toggleAttribute('aria-busy', isLoading);
        window.clearTimeout(this.loadingTimeout);
        if (isLoading) {
          this.loadingTimeout = window.setTimeout(() => this.setLoading(false), 8000);
        }
      }

      onVariantChange(data) {
        if (!data) return;
        const { html, variant, sectionId } = data;

        if (html && this.priceEl && !this.hasTiers) {
          const freshPrice = html.getElementById(`price-${sectionId}`);
          if (freshPrice) this.priceEl.innerHTML = freshPrice.innerHTML;
        }

        if (variant) {
          this.variantTitle = variant.title && variant.title !== 'Default Title' ? variant.title : '';
          this.renderVariantLine();

          const src =
            (variant.featured_image && variant.featured_image.src) ||
            (variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src);
          if (src && this.imageEl) {
            try {
              const url = new URL(src, window.location.origin);
              url.searchParams.set('width', '120');
              this.imageEl.src = url.toString();
            } catch (error) {
              this.imageEl.src = src;
            }
          }
        }
      }

      renderVariantLine() {
        if (!this.variantEl) return;
        const parts = [this.variantTitle, this.tierLabel].filter(Boolean);
        this.variantEl.textContent = parts.join(' · ');
      }
    }
  );
}
